// src/pages/TestimonialPage.jsx

import React from 'react';
import Navbar from '../components/navbar';
import Footer from '../components/footer';
import StarRating from '../components/starRating';
import '../styles/testimonialPage.css';

function TestimonialPage() {
  return (
    <>
      <Navbar />

      <section className="testimonials-page">
        <div className="testimonials-hero">
          <h1>What Our Patients Say</h1>
          <p>Your trust is our pride. Here's what our community says about Mirror Lake Pharmacy.</p>
        </div>

        <div className="testimonial-grid">
        <div className="testimonial-card">
            <p>"Cameron and the Mirror Lake Pharmacy team have been so great with me and my family! Always going above and beyond to help anyway they can."</p>
            <StarRating rating={5} /> 
            <h4>- Celina D.</h4>
          </div>

          <div className="testimonial-card">
            <p>"Very friendly group of pharmacists, great communication and they offer delivery services! We’ve had nothing but positive experiences dealing with them."</p>
            <StarRating rating={5} /> 
            <h4>- Chris Dinh.</h4>
          </div>

          <div className="testimonial-card">
            <p>"Great Pharmacist & excellent services! These guys provide walk in clinic services too! 100% recommended"</p>
            <StarRating rating={5} /> 
            <h4>- Sahil Patel.</h4>
          </div>

          <div className="testimonial-card">
            <p>"Cam filled our prescriptions very quickly and was helpful with our insurance!"</p>
            <StarRating rating={5} /> 
            <h4>- Chelsea P.</h4>
          </div>

          <div className="testimonial-card">
            <p>"Excellent service, great selection of health products, and very helpful advice. Highly recommended!"</p>
            <StarRating rating={5} /> 
            <h4>- Michael T.</h4>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default TestimonialPage;